export default "__VITE_ASSET__CGChrbNh__"